import { render, staticRenderFns } from "./PointsOfInterest.vue?vue&type=template&id=40fe82e2&"
import script from "./PointsOfInterest.vue?vue&type=script&lang=js&"
export * from "./PointsOfInterest.vue?vue&type=script&lang=js&"
import style0 from "./PointsOfInterest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports